import { createFileRoute } from "@tanstack/react-router";
import { SiteRosterFeature } from "@/features/site-roster";

export const Route = createFileRoute("/scheduler/site-roster/")({
  component: SiteRosterFeature,
  staticData: { authorize: true },
});
